import { PRERENDER_ROUTES } from '@/prerender';
export { PRERENDER_ROUTES };

export type PrerenderRoute = (typeof PRERENDER_ROUTES)[number];

export function isPrerenderRoute(route: string): route is PrerenderRoute {
    return PRERENDER_ROUTES.includes(route as PrerenderRoute);
}
